import { ScenarioDataSources } from '../../shared/queries/scenarios';

export const ModalNames = {
  Delete: 'SCENARIO_REMOVE_MODAL',
};

export const ModalTitles = {
  Delete: 'Delete scenario',
};

export const DataSources = {
  TLS: 'TLS',
  Copy: 'COPY',
  Empty: 'EMPTY',
};


export const dataSourcesOptions = [
  {
    label: 'TLS',
    value: ScenarioDataSources.TLS,
  },
  {
    label: 'Empty',
    value: ScenarioDataSources.Empty,
  },
];

export const yesNoFlagOptions = [
  { value: 'Y', label: 'Y' },
  { value: 'N', label: 'N' },
];
